<mat-card>
    <mat-card-title class="font-weight-bold caption-color">Discount View</mat-card-title>
    <mat-divider></mat-divider>
    <mat-card-content class="pt-2">

<table class="table">
    <thead>
        <tr class="text-right pr-10">


            <th class="w-10" *ngIf="!SpraDiscountView.IsRental">Order Value </th>
            <th class="w-10" *ngIf="!SpraDiscountView.IsRental">Warranty cost</th>
            <th class="w-10" *ngIf="!SpraDiscountView.IsRental"> Dealer/Agent Comm</th>
            <th class="w-10" *ngIf="!SpraDiscountView.IsRental">BuyBack</th>
            <th class="w-10" *ngIf="!SpraDiscountView.IsRental">Resale Value of Buyback</th>
            <th class="w-10" *ngIf="!SpraDiscountView.IsRental"> Install. comm. </th>
            <th class="w-10" *ngIf="!SpraDiscountView.IsRental">Bought out Items</th>
            <th class="w-10" *ngIf="!SpraDiscountView.IsRental">Rebate w/o GST</th>
            <th class="w-10 pr-5" *ngIf="!SpraDiscountView.IsRental">Net Sale Price Realised</th>

                <th class="w-15" *ngIf="SpraDiscountView.IsRental">Order Value </th>
                <th class="w-15" *ngIf="SpraDiscountView.IsRental"> Dealer/Agent Comm</th>
                <th class="w-15" *ngIf="SpraDiscountView.IsRental"> Install. comm. </th>
                <th class="w-15" *ngIf="SpraDiscountView.IsRental">Free Item</th>
                <th class="w-15" *ngIf="SpraDiscountView.IsRental">Other</th>
                <th class="w-15 pr-5"  *ngIf="SpraDiscountView.IsRental">Net Sale Price Realised</th>
        </tr>
    </thead>
    <tbody>
        <tr class="text-right">
            
            <td class="int">
              {{SpraDiscountView.TotalPurOrderVal | number : '1.2-2'}}
            </td>
            <td *ngIf="!SpraDiscountView.IsRental">
                -{{SpraDiscountView.warrantycost | number : '1.2-2'}}
            </td>
            <td>
               -{{SpraDiscountView.DealerComm | number : '1.2-2'}}
            </td>
            <td  *ngIf="!SpraDiscountView.IsRental">
                -{{SpraDiscountView.BuyBack | number : '1.2-2'}}
            </td>
            <td  *ngIf="!SpraDiscountView.IsRental">
               +{{SpraDiscountView.ResaleBuyBackVal | number : '1.2-2'}}
            </td>  
            <td >
               -{{SpraDiscountView.InstallComm | number : '1.2-2'}}
            </td>  
            <td  *ngIf="!SpraDiscountView.IsRental">
               -{{SpraDiscountView.BoughtOutItmes | number : '1.2-2'}}
            </td>  
            <td  *ngIf="!SpraDiscountView.IsRental">
               -{{SpraDiscountView.RebatewoGST  | number : '1.2-2' }}
            </td>
            <td *ngIf="SpraDiscountView.IsRental">-{{SpraDiscountView.FreeItem | number : '1.2-2'}}</td>
            <td *ngIf="SpraDiscountView.IsRental">-{{SpraDiscountView.Other | number : '1.2-2'}}</td>
            <td class="pr-5">
                {{SpraDiscountView.NetSalePriceRealised | number : '1.2-2'}}
                <!-- {{(SpraDiscountView.TotalPurOrderVal- SpraDiscountView.warrantycost - SpraDiscountView.DealerComm -SpraDiscountView.BuyBack  -SpraDiscountView.InstallComm -SpraDiscountView.BoughtOutItmes -SpraDiscountView.RebatewoGST) + SpraDiscountView.ResaleBuyBackVal*1}} -->
            </td>                
           
        </tr>
    </tbody>
</table>
</mat-card-content>
</mat-card>